import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { K2User } from '@k2/common/entities-state/types';

@Component({
    selector: 'k2-user-ingot',
    templateUrl: 'k2-user-ingot.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class K2UserIngotComponent {
  @Input() user: K2User;
}
